const AUTH_TOKEN = $('meta[name="csrf-token"]').attr('content');

window.CreateDealSampleRequest = {
    init() {
        this.initDropZone();
    },

    initDropZone() {
        const submitButton = document.getElementById('samples-continue-modal-btn');
        const self = this

        const showPreviewLoader = (file) => {
            if (!file?.previewElement) return;
            $(file.previewElement).find('.dz-uploading-loader').removeClass('d-none');
            $(file.previewElement).find('.dz-remove').addClass('d-none'); // avoid removing mid-upload
        };

        const hidePreviewLoader = (file) => {
            if (!file?.previewElement) return;
            $(file.previewElement).find('.dz-uploading-loader').addClass('d-none');
            $(file.previewElement).find('.dz-remove').removeClass('d-none');
        };

        $(".add-sample-request-btn").not(".dz-clickable").each((index, element) => {
            $(element).dropzone({
                url: "/deal_sample_requests/upload_deal_sample_request_attachment",
                previewsContainer: document.querySelector('.drop-zone-preview.sample-request'),
                previewTemplate: document.querySelector('.drop-zone-custom.sample-request').innerHTML,
                uploadMultiple: false,
                maxFiles: 10,
                maxFileSize: 10,
                acceptedFiles: ".jpg,.jpeg,.gif,.png,.tiff,.bmp,.webp,.txt,.csv,.pdf,.xls,.xlsx,.xlsm,.doc,.docx,.zip",
                init: function () {
                    this.on("error", function (file) {
                        hidePreviewLoader(file);
                        this.removeFile(file);
                        $('#deal-sample-request-attachments').after(
                            '<div class="alert alert-danger alert-dismissable" id="rr-success-alert">' +
                            '<button type="button" class="close" ' +
                            'data-dismiss="alert" aria-hidden="true">' +
                            '&times;' +
                            '</button>' +
                            'An error has occurred uploading file' +
                            '</div>'
                        );
                        submitButton.disabled = false;
                    });

                    this.on("complete", function (file) {
                        hidePreviewLoader(file);
                    });
                },
                params: {
                    'authenticity_token': AUTH_TOKEN
                },
                timeout: 60000,
                success: (file, response) => {
                    if (response.err_msg == '' || response.err_msg == undefined) {
                        const dealSampleRequestAttachmentsElement = $("#deal-sample-request-attachments");
                        $(file.previewElement).find('.remove-attachment').attr('data-attachment-id', response.id);
                        dealSampleRequestAttachmentsElement.append(`<input type='hidden' value='${response.id}' name='deal_sample_request[deal_sample_request_attachment_ids][]'>`);
                        self.handleOnClickRemoveAttachment();
                    } else {
                        alert(response.err_msg);
                        file.previewElement.remove();
                    }
                    submitButton.disabled = false;
                },
                sending: (file) => {
                    showPreviewLoader(file);
                    submitButton.disabled = true;
                }
            });
        });

        $("#rr-success-alert").fadeTo(5000, 500).slideUp(500, function () {
            $("#rr-success-alert").slideUp(500);
        });
        setTimeout(function () {
            $("#rr-success-alert").remove();
        }, 6000);
    },

    handleRemoveAttachment(e) {
        const attachmentId = e.target.dataset.attachmentId;
        $(`#deal-sample-request-attachments :input[value="${attachmentId}"]`).remove();
        $(e.target).parents('.drop-zone-preview.sample-request').remove();
    },

    handleOnClickRemoveAttachment() {
        $(".remove-attachment").on('click', this.handleRemoveAttachment.bind(this));
    },
};
